import { supabaseFunctionsProvider } from "../../providers/supabase/functions";

const functionsProvider = supabaseFunctionsProvider;

/**
 * Invoca una función de servidor de manera agnóstica.
 * @param {string} functionName - Nombre de la función.
 * @param {object} options - Opciones de la petición.
 */
export const invokeFunction = async (functionName, options = {}) => {
  return await functionsProvider.invoke(functionName, options);
};
